import { IModules } from './interfaces';

export const initState: IModules = {
  startState: [],
  modules: [],
  breakpoint: 'lg',
};
